module.exports = __webpack_public_path__ + "static/ray-3b849ff52d7112adb1c1828765a37a6a.png";